module.exports = __webpack_public_path__ + "img/defaultCoinIco.16d69441.png";